// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  message: string,
  isNotice?: boolean,
  onRetry?: Function,
}

export default function LoadFailedView({ message, isNotice, onRetry }: Props) {
  const { t } = useTranslation();

  // Отказ по правам - это не сбой: рассказываем спокойно и без кнопки повтора
  if (isNotice) {
    return (
      <div className="alert alert-info mb-0">
        {message}
      </div>
    );
  }

  return (
    <div className="alert alert-danger">
      <p>
        <strong>{t('Load failed.')}</strong>
        {onRetry && (
          <button type="button" className="btn btn-link" onClick={onRetry}>{t('Click to retry')}</button>
        )}
      </p>
      <p>{message}</p>
    </div>
  );
}
